export const SET_ASSUMPTIONS = "SET_ASSUMPTIONS";